<template>
  <load-content :loading="isReady == false">
    <main-header v-if="showHeader" ref="main-header" :headerBaseName="headerBaseName" :headerPrimaryName="`${headerPrimaryName ? '/ ' + headerPrimaryName : ''}`" :headerSecondaryName="headerSecondaryName" :isExpired="isExpired" :clientId="clientId" :expiredFor="expiredFor" :isAdmin="isAdmin"/>
    <div ref="main-content" class="main-content" :class="mainContentClass">
      <router-view @loadSelectedProject="loadSelectedProject" @setHeaderPrimaryName="onSetHeaderPrimaryName" @setHeaderSecondaryName="onSetHeaderSecondaryName" />
    </div>
  </load-content>
</template>

<script>
import Vue from 'vue';
import i18n from '@/i18n';
import { mapState, mapActions } from 'vuex';
import LoadContent from '@/components/load-content';
import MainHeader from '@/layouts/main-header';
import setMarginTop from '@/helpers/setMarginTop.js';

export default {
  data: function() {
    return {
      headerBaseName: 'Coding / Projects',
      headerPrimaryName: '',
      headerSecondaryName: null,
      isExpired: false,
      isReady: false
    }
  },
  mounted() {
    this.loadSelectedProject().then(r => {
      this.isReady = true;
    }, error => {
      console.error('error', error);
    });

    window.addEventListener("resize", this.setMarginTopMain)
  },

  updated(){
    this.$nextTick(() => {
      this.setMarginTopMain();
    });
  },

  beforeDestroy: function(){
    window.removeEventListener("resize", this.setMarginTopMain);
  },

  computed: {
    projectUid() {
      return this.$route.params.project_uid;
    },
    isAdmin(){
      return this.user ? this.user.role.admin === true : null
    },
    clientId() {
      return this.project ? this.project.client_id : null;
    },
    expiredFor(){
      const formattedDate = 
      new Date(this.project ? this.project.end_date : null)
      .toLocaleString('default', { month: 'long' }) + ' ' + 
      new Date(this.project ? this.project.end_date : null).getDate() + ', ' + 
      new Date(this.project ? this.project.end_date : null)
      .getFullYear();
      return formattedDate;
    },
    ...mapState({
      isInsight: state => state.isInsight,
      user: state => state.user.user.data,
      project: state => state.projects.project.data,
    }),
    showHeader() {
      if(this.isInsight) return false
      return true
    },
    mainContentClass() {
      let customClass = ''
      if(this.isInsight)  customClass += 'mt0'
      return customClass
    }
  },

  methods: {
    onSetHeaderPrimaryName: function(value) {
      this.headerPrimaryName = value;
    },

    onSetHeaderSecondaryName: function(value) {
      this.headerSecondaryName = value;
    },

    setMarginTopMain(e){      
      const mainHeader = this.$refs["main-header"];
      const mainContent = this.$refs["main-content"];      
      mainHeader && (mainHeader.$el && mainHeader.$el.childNodes.length) && mainContent && setMarginTop(mainHeader.$el, mainContent, 0);
    },

    loadSelectedProject(projectId = null) {
      return new Promise((resolve, reject) => {
        try {
          const pId = projectId || this.projectUid;
          if (pId != undefined) {
            this.getProject({ projectUid: pId }).then(r => {
              this.headerPrimaryName = this.project.project_name;
              this.isExpired = this.project.is_expired;
              resolve();
            });
          }
          else {
            resolve();
          }
        }
        catch (e) {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
          reject(e);
        }
      });
    },

    ...mapActions({
      getProject: 'projects/getProject'
    })
  },

  components: {
    MainHeader,
    LoadContent
  }
};
</script>